module.exports = __webpack_public_path__ + "img/Tracks-Electro-mob.d35bf39d.webp";